import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import useStore from '../../store';
import './Sidebar.css';

const NAV_CONFIG = {
  employee: [
    { section: 'Overview', items: [
      { path: '/dashboard', icon: '⬡', label: 'Dashboard' },
      { path: '/attendance', icon: '◷', label: 'My Attendance' },
      { path: '/leaves', icon: '☂', label: 'My Leaves' },
      { path: '/holidays', icon: '◈', label: 'Holidays' },
    ]},
    { section: 'Account', items: [
      { path: '/profile', icon: '◉', label: 'My Profile' },
    ]},
  ],
  manager: [
    { section: 'Overview', items: [
      { path: '/dashboard', icon: '⬡', label: 'Dashboard' },
      { path: '/attendance', icon: '◷', label: 'My Attendance' },
      { path: '/leaves', icon: '☂', label: 'My Leaves' },
      { path: '/holidays', icon: '◈', label: 'Holidays' },
    ]},
    { section: 'Team', items: [
      { path: '/team/attendance', icon: '⊞', label: 'Team Attendance' },
      { path: '/team/leaves', icon: '✦', label: 'Leave Approvals' },
      { path: '/team/overview', icon: '◈', label: 'Team Overview' },
    ]},
    { section: 'Account', items: [
      { path: '/profile', icon: '◉', label: 'My Profile' },
    ]},
  ],
  admin: [
    { section: 'Overview', items: [
      { path: '/dashboard', icon: '⬡', label: 'Dashboard' },
      { path: '/attendance', icon: '◷', label: 'My Attendance' },
      { path: '/leaves', icon: '☂', label: 'My Leaves' },
      { path: '/holidays', icon: '◈', label: 'Holidays' },
    ]},
    { section: 'Team', items: [
      { path: '/team/attendance', icon: '⊞', label: 'Team Attendance' },
      { path: '/team/leaves', icon: '✦', label: 'Leave Approvals' },
      { path: '/team/overview', icon: '◈', label: 'Team Overview' },
    ]},
    { section: 'Admin', items: [
      { path: '/admin/users', icon: '◈', label: 'User Management' },
      { path: '/admin/holidays', icon: '◇', label: 'Manage Holidays' },
      { path: '/admin/departments', icon: '⊟', label: 'Departments' },
      { path: '/admin/leave-policies', icon: '▤', label: 'Leave Policies' },
      { path: '/admin/report', icon: '▣', label: 'Report' },
    ]},
    { section: 'Account', items: [
      { path: '/profile', icon: '◉', label: 'My Profile' },
    ]},
  ],
};

export default function Sidebar() {
  const { user, logout, sidebarCollapsed } = useStore();
  const navigate = useNavigate();
  const role = user?.role || 'employee';
  const sections = NAV_CONFIG[role] || NAV_CONFIG.employee;

  const initials = user
    ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase()
    : 'U';

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <aside className={`sidebar ${sidebarCollapsed ? 'sidebar--collapsed' : ''}`}>
      {/* Logo */}
      <div className="sidebar-logo">
        <div className="sidebar-logo-mark">A</div>
        {!sidebarCollapsed && <span className="sidebar-logo-text">Aays</span>}
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {sections.map((section) => (
          <div key={section.section} className="sidebar-section">
            {!sidebarCollapsed && (
              <span className="sidebar-section-label">{section.section}</span>
            )}
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `sidebar-link ${isActive ? 'sidebar-link--active' : ''}`
                }
                title={sidebarCollapsed ? item.label : undefined}
              >
                <span className="sidebar-link-icon">{item.icon}</span>
                {!sidebarCollapsed && (
                  <span className="sidebar-link-label">{item.label}</span>
                )}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      {/* Bottom: user + logout */}
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="avatar avatar-sm" style={{ background: 'var(--brand-violet)' }}>
            {initials}
          </div>
          {!sidebarCollapsed && (
            <div className="sidebar-user-info">
              <span className="sidebar-user-name">{user?.first_name} {user?.last_name}</span>
              <span className="sidebar-user-role">{role}</span>
            </div>
          )}
        </div>
        <button className="sidebar-logout" onClick={handleLogout} title="Logout">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          {!sidebarCollapsed && <span>Logout</span>}
        </button>
      </div>
    </aside>
  );
}
